import React, { useEffect, useRef, useState } from "react";
import './NewMain.css'
import { BASE_URL, get, post, put } from "../../Services/Calls";
import { Header } from "../../components";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import BlueCheck from '../../data/blueCheck.png'
import SelectedCheck from '../../data/selectedCheck.png'
import UnCheck from '../../data/unCheck.png'
import "../../pages/NewPages/Map/MapBox.css";
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import S3FileUpload from '../../components/S3FileUpload'
import { addPoiDayGrid, addGpxsDayGrid, poiGrid } from "../../data/dummy";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Inject,
  Toolbar,
  Filter,
  ColumnChooser
} from "@syncfusion/ej2-react-grids";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DropDownArrow from '../../data/rightArrow.png';
import { mapboxglAccessToken, notify } from "../../Services/Utils";
import { setGridVisibility, getGridVisibility } from '../../Services/gridVisibilityHelper';

mapboxgl.accessToken = mapboxglAccessToken;


const CreateDay = () => {

  const navigate = useNavigate()
  const location = useLocation();
  const { friendlyId: friendlyIdParam } = useParams();

  const gridRef = useRef(null);
  const gridGpxRef = useRef(null);
  const toolbarOptions = ['Search', 'ColumnChooser'];
  /* const FilterOptions = {
    type: 'Excel'
  }; */
  const [FilterOptions, setFilterOptions] = useState({ type: 'Excel' });
  const editOptions = {
    allowEditing: false,
    allowAdding: true,
    allowDeleting: true
  }
  const [dayName, setDayName] = useState('');
  const [overnight, setOvernight] = useState('');
  const [imageName, setImageName] = useState('');
  const [description, setDescription] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [fromStatus, setFromStatus] = useState('');
  const [dayId, setDayId] = useState('');
  const [friendlyId, setFriendlyId] = useState('');
  const [poiSort, setPoiSort] = useState('');
  const [showImagePopUp, setShowImagePopUp] = useState(false);
  const [showCountrySelect, setShowCountrySelect] = useState(false);
  const [direction, setDirection] = useState("ltr");  // Initial direction is left-to-right

  const [dayStartPoint, setDayStartPoint] = useState('');
  const [countryData, setCountryData] = useState([]);
  const [country, setCountry] = useState({});
  const countryRef = useRef({});
  const [dayEndPoint, setDayEndPoint] = useState('');
  const [personalized, setPersonalized] = useState(true);
  const [poiData, setPoiData] = useState([])
  const [gpxsData, setGpxsData] = useState([])
  const poiDataRef = useRef([])
  const gpxsDataRef = useRef([])
  const [selectedRecords, setSelectedRecords] = useState([])
  const selectedRecordsRef = useRef([])
  const [poiIdArray, setPoiIdArray] = useState([]);
  const [gpxsIdArray, setGpxsIdArray] = useState([]);
  const gpxsIdArrayRef = useRef([]);
  const poiIdArrayRef = useRef([]);

  const [map, setMap] = useState(null);
  const [mapStyle, setMapStyle] = useState('mapbox://styles/mapbox/streets-v11');
  const [mapMode, setMapMode] = useState('1');

  const mapRef = useRef(null);
  const mapRef2 = useRef(null);
  const markerRef = useRef(null);
  const marker2Ref = useRef(null);
  const [loading, setLoading] = useState(false);
  const toggleDirection = () => {
    setDirection((prevDirection) => (prevDirection === "ltr" ? "rtl" : "ltr"));
  };



  //new
  const applyCountryFilter = (selectedCountry) => {
    if (!gridRef.current) return;

    if (!selectedCountry || !selectedCountry.name) {
      console.error('Selected country is invalid or missing a name');
      return;
    }
    const filters = [];
    filters.push({
      field: "country.name",  // Make sure this matches the field in your data
      operator: 'equal',
      value: selectedCountry.name,
      predicate: 'or',
      matchCase: false,
    });
    if (poiDataRef.current.length > 0) {
      gridRef.current.filterSettings = { columns: filters };
      gridRef.current.refresh();
      if (gridRef.current && gridRef.current.filterSettings.columns) {
        // Clean up any invalid filters with missing fields or invalid predicates
        gridRef.current.filterSettings.columns = gridRef.current.filterSettings.columns.filter(
          (col) => col && col.field && col.predicate
        );
      }
    }
    if (gpxsDataRef.current.length > 0) {
      gridGpxRef.current.filterSettings = { columns: filters };
      gridGpxRef.current.refresh();
      if (gridGpxRef.current && gridGpxRef.current.filterSettings.columns) {
        // Clean up any invalid filters with missing fields or invalid predicates
        gridGpxRef.current.filterSettings.columns = gridGpxRef.current.filterSettings.columns.filter(
          (col) => col && col.field && col.predicate
        );
      }
    }

  };
  //new







  //super new
  const pageKey = 'create-day-poi-page'; // unique key for each page
  const [isReady, setIsReady] = useState(false);
  const [columnSettings, setColumnSettings] = useState([]);

  useEffect(() => {
    const saved = getGridVisibility(pageKey);
    if (saved) setColumnSettings(saved);
    setIsReady(true);

  }, []);





  const finalColumns = addPoiDayGrid.map((col) => {
    if (!col.field) return col; // Skip if no field (like checkbox/template)

    const match = columnSettings?.find((c) => c.field === col.field);
    return match
      ? { ...col, visible: match.visible }    // apply visibility state
      : { ...col };                           // fallback: visible by default
  });





  const onActionComplete = (args) => {
    if (args.requestType === 'columnstate') {
      const gridCols = gridRef.current?.getColumns() ?? [];
      const state = gridCols
        .filter((c) => !!c.field)
        .map((c) => ({
          field: c.field,
          visible: c.visible,
        }));
      setGridVisibility(pageKey, state);
    }
  };




  const pageKey1 = 'create-day-gpx-page'; // unique key for each page
  const [isReady1, setIsReady1] = useState(false);
  const [columnSettings1, setColumnSettings1] = useState([]);


  useEffect(() => {
    const saved1 = getGridVisibility(pageKey1);
    if (saved1) setColumnSettings1(saved1);

    setIsReady1(true);
  }, []);

  const finalColumns1 = addGpxsDayGrid.map((col) => {
    if (!col.field) return col; // Skip if no field (like checkbox/template)

    const match = columnSettings1?.find((c) => c.field === col.field);
    return match
      ? { ...col, visible: match.visible }    // apply visibility state
      : { ...col };                           // fallback: visible by default
  });

  const onActionComplete1 = (args) => {
    if (args.requestType === 'columnstate') {
      const gridCols = gridGpxRef.current?.getColumns() ?? [];
      const state = gridCols
        .filter((c) => !!c.field)
        .map((c) => ({
          field: c.field,
          visible: c.visible,
        }));
      setGridVisibility(pageKey1, state);
    }
  };
  //super new






























  const getPoi = async () => {
    try {
      const response = await get(BASE_URL + '/pois')
      if (response && response.results && response.results.length > 0) {
        let responseData = response.results
        let json = { selected: false }
        response.results.forEach(item => {
          item.typeData = 'POI'
        })
        for (let i = 0; i < responseData.length; i++) {
          responseData[i] = { ...responseData[i], ...json }
        }
        // setPoiData(response.results)


        const saved = localStorage.getItem("selectedCountry");
        if (saved) {
          const filteredResults = responseData.filter(item => String(item.country?.id) === String(saved));
          setPoiData(filteredResults);
          poiDataRef.current = filteredResults
        }
        else {
          setPoiData(responseData)
          poiDataRef.current = responseData
        }




        if (countryRef.current && countryRef.current.name) {
          setTimeout(() => {
            applyCountryFilter(countryRef.current)
          }, 1000);

        }

      }
    }
    catch (ex) {
      alert(ex)
    }
    finally {
      setLoading(false);
    }
  }
  const getGpxs = async () => {
    try {
      const response = await get(BASE_URL + '/gpx')
      if (response && response.results && response.results.length > 0) {
        response.results.forEach(item => {
          item.typeData = 'GPX'
        })
        let responseData = response.results
        let json = { selected: false }
        for (let i = 0; i < responseData.length; i++) {
          responseData[i] = { ...responseData[i], ...json }
        }
        // setPoiData(response.results)
        const saved = localStorage.getItem("selectedCountry");
        if (saved) {
          const filteredResults = responseData.filter(item => String(item.country?.id) === String(saved));
          setGpxsData(filteredResults);
          gpxsDataRef.current = filteredResults
        }
        else {
          setGpxsData(responseData)
          gpxsDataRef.current = responseData
        }
        if (countryRef.current && countryRef.current.name) {
          setTimeout(() => {
            applyCountryFilter(countryRef.current)
          }, 1000);
        }


      }
    }
    catch (ex) {
      alert(ex)
    }
    finally {
      setLoading(false);
    }
  }

  const getCountries = async () => {
    try {
      const response = await get(BASE_URL + '/countries?order=ASC');
      if (response && response.length > 0) {
        setCountryData(response);
      }
    }
    catch (ex) {
      alert(ex)
    }
  }

  const getPoiEdit = async (tempIdArray) => {
    try {
      const response = await get(BASE_URL + "/pois");
      if (response && response.results && response.results.length > 0) {
        response.results.forEach(item => {
          item.typeData = 'POI'
        })
        let tempDaysData = response.results
        if (tempIdArray && tempIdArray.length > 0) {
          for (let i = 0; i < tempDaysData.length; i++) {
            let status = false
            for (let j = 0; j < tempIdArray.length; j++) {
              if (tempDaysData[i].id == tempIdArray[j]) {
                status = true
              }
            }
            if (status) {
              tempDaysData[i] = { ...tempDaysData[i], ...{ selected: true } }
            }
            else {
              tempDaysData[i] = { ...tempDaysData[i], ...{ selected: false } }
            }
          }
        }

        const saved = localStorage.getItem("selectedCountry");
        if (saved) {
          const filteredResults = tempDaysData.filter(item => String(item.country?.id) === String(saved));
          setPoiData(filteredResults);
          poiDataRef.current = filteredResults

        }
        else {
          setPoiData(tempDaysData)
          poiDataRef.current = tempDaysData
        }



        setPoiIdArray(tempIdArray)
        poiIdArrayRef.current = tempIdArray

        if (countryRef.current && countryRef.current.name) {
          setTimeout(() => {
            applyCountryFilter(countryRef.current)
          }, 1000);

        }

      }
    }
    catch (ex) {
      alert(ex)
    }
  };

  const getGpxsEdit = async (tempIdArray) => {
    try {
      const response = await get(BASE_URL + "/gpx");
      if (response && response.results && response.results.length > 0) {
        response.results.forEach(item => {
          item.typeData = 'GPX'
        })
        let tempDaysData = response.results
        if (tempIdArray && tempIdArray.length > 0) {
          for (let i = 0; i < tempDaysData.length; i++) {
            let status = false
            for (let j = 0; j < tempIdArray.length; j++) {
              if (tempDaysData[i].id == tempIdArray[j]) {
                status = true
              }
            }
            if (status) {
              tempDaysData[i] = { ...tempDaysData[i], ...{ selected: true } }
            }
            else {
              tempDaysData[i] = { ...tempDaysData[i], ...{ selected: false } }
            }
          }
        }

        const saved = localStorage.getItem("selectedCountry");
        if (saved) {
          const filteredResults = tempDaysData.filter(item => String(item.country?.id) === String(saved));
          setGpxsData(filteredResults);
          gpxsDataRef.current = filteredResults
        }
        else {
          setGpxsData(tempDaysData)
          gpxsDataRef.current = tempDaysData
        }
        setGpxsIdArray(tempIdArray)
        gpxsIdArrayRef.current = tempIdArray

        if (countryRef.current && countryRef.current.name) {
          setTimeout(() => {
            applyCountryFilter(countryRef.current)
          }, 1000);

        }
      }
    }
    catch (ex) {
      alert(ex)
    }
  };

  useEffect(() => {
    // Create a map instance
    mapRef.current = new mapboxgl.Map({
      container: 'map', // Specify the container ID
      style: mapStyle, // Specify the map style
      center: [32.00, 35.00], // Specify the starting center
      zoom: 6, // Specify the starting zoom
    });
    mapRef.current.addControl(new mapboxgl.NavigationControl());

    mapRef.current.on('load', () => {
      setMap(mapRef.current);
    });


    mapRef.current.on('style.load', function () {
      mapRef.current.on('click', function (e) {
        var coordinates = e.lngLat;
        new mapboxgl.Popup()
        if (markerRef.current != null) {
          markerRef.current.remove()
        }
        markerRef.current = new mapboxgl.Marker()
          .setLngLat(coordinates)
          .addTo(mapRef.current);
        setDayStartPoint(coordinates.lat + "," + coordinates.lng)
        mapRef.current.flyTo({ center: [coordinates.lng, coordinates.lat], zoom: 10 });
      });
    });

    // Clean up the map instance when the component unmounts
    return () => mapRef.current.remove();
  }, [mapStyle, mapMode]); // The empty dependency array ensures this useEffect runs only once

  useEffect(() => {
    // Create a map instance
    mapRef2.current = new mapboxgl.Map({
      container: 'map2', // Specify the container ID
      style: mapStyle, // Specify the map style
      center: [32.00, 35.00], // Specify the starting center
      zoom: 10, // Specify the starting zoom
    });
    mapRef2.current.addControl(new mapboxgl.NavigationControl());
    mapRef2.current.on('load', () => {
      setMap(mapRef2.current);
    });

    mapRef2.current.on('style.load', function () {
      mapRef2.current.on('click', function (e) {
        var coordinates = e.lngLat;
        new mapboxgl.Popup()
        if (marker2Ref.current != null) {
          marker2Ref.current.remove()
        }
        marker2Ref.current = new mapboxgl.Marker()
          .setLngLat(coordinates)
          // .setHTML('' + coordinates)
          .addTo(mapRef2.current);
        setDayEndPoint(coordinates.lat + "," + coordinates.lng);
        mapRef2.current.flyTo({ center: [coordinates.lng, coordinates.lat], zoom: 10 });
      });
    });
    // Clean up the map instance when the component unmounts
    return () => mapRef2.current.remove();
  }, [mapStyle, mapMode]); // The empty dependency array ensures this useEffect runs only once

  const populateDayForm = (dayData) => {
    setDayName(dayData.name);
    setOvernight(dayData.overnight);
    setDescription(dayData.description);
    setImageName(dayData.imageURL);
    setCountry(dayData.country);
    countryRef.current = dayData.country
    setDayStartPoint(dayData.start_latitude + "," + dayData.start_longitude)
    setDayEndPoint(dayData.end_latitude + "," + dayData.end_longitude)
    setDayId(dayData.id);
    setFriendlyId(dayData.friendly_id);
    setPersonalized(dayData.personalized);
    setPoiSort(dayData.poi_set_sort);
    if (dayData.poi_set && dayData.poi_set.length > 0) {
      dayData.poi_set.forEach(item => {
        item.typeData = 'POI';
      })
    }
    if (dayData.gpx_set && dayData.gpx_set.length > 0) {
      dayData.gpx_set.forEach(item => {
        item.typeData = 'GPX';
      })
    }
    const sort = dayData.poi_set_sort;
    const arrDataSelected = [...dayData.poi_set, ...dayData.gpx_set];
    if (sort !== null && sort !== undefined && sort !== "") {
      const arrDataSelected = [...dayData.poi_set, ...dayData.gpx_set];
      const sortedData = sort.split(',').map(id => arrDataSelected.find(item => item.id === id));
      setSelectedRecords(sortedData?.filter(record => record !== null && record !== undefined));
      selectedRecordsRef.current = sortedData?.filter(record => record !== null && record !== undefined);
    } else {
      setSelectedRecords(arrDataSelected?.filter(record => record !== null && record !== undefined));
      selectedRecordsRef.current = arrDataSelected?.filter(record => record !== null && record !== undefined);
    }

    let tempPois = dayData.poi_set
    let tempGpxs = dayData.gpx_set
    let tempIdArrayPois = []
    let tempIdArrayGpxs = []
    for (let i = 0; i < tempPois.length; i++) {
      tempIdArrayPois.push(tempPois[i].id);
    }
    for (let i = 0; i < tempGpxs.length; i++) {
      tempIdArrayGpxs.push(tempGpxs[i].id);
    }
    setPoiIdArray(tempIdArrayPois);
    poiIdArrayRef.current = tempIdArrayPois;
    getPoiEdit(tempIdArrayPois);

    setGpxsIdArray(tempIdArrayGpxs);
    gpxsIdArrayRef.current = tempIdArrayGpxs;
    getGpxsEdit(tempIdArrayGpxs);

    markerRef.current = new mapboxgl.Marker()
      .setLngLat([dayData.start_longitude, dayData.start_latitude])
      .addTo(mapRef.current);
    mapRef.current.flyTo({ center: [dayData.start_longitude, dayData.start_latitude], zoom: 10 });

    marker2Ref.current = new mapboxgl.Marker()
      .setLngLat([dayData.end_longitude, dayData.end_latitude])
      .addTo(mapRef2.current);
    mapRef2.current.flyTo({ center: [dayData.end_longitude, dayData.end_latitude], zoom: 10 });
  };

  useEffect(() => {
    (async () => {
      await getCountries();

      if (location && location.state && location.state.from) {
        setFromStatus(location.state.from);
        if (location.state.from == 'create') {
          getPoi();
          getGpxs();
        }
        if (location.state.data && location.state.data.id) {
          populateDayForm(location.state.data);
        }
      } else if (friendlyIdParam) {
        // Deep link (e.g. /editDay/2) — no row data was handed off via
        // navigation state, so fetch the day by its friendly id instead.
        try {
          const dayData = await get(`${BASE_URL}/days/friendlyId/${friendlyIdParam}`);
          if (dayData && dayData.id) {
            setFromStatus('edit');
            populateDayForm(dayData);
          } else {
            setErrorMsg('Day not found');
          }
        } catch (ex) {
          alert(ex);
        }
      }
    })();

    window.scrollTo(0, 0);
  }, []);

  async function createDayFun() {
    let tempDayStartPoint = dayStartPoint.split(',')
    let tempDayEndPoint = dayEndPoint.split(',')
    if (dayName == '' || dayName == undefined) {
      setErrorMsg('Please Enter Day Name');
      return;
    }

    if (overnight == '' || overnight == undefined) {
      setErrorMsg('Please Enter Overnight value');
      return;
    }

    if (imageName && imageName != '') { }
    else {
      setErrorMsg('Please Upload Day Image');
      return;
    }

    if (description == '' || description == undefined) {
      setErrorMsg('Please Enter Day Description');
      return;
    }

    if (dayStartPoint == '' || dayStartPoint == undefined) {
      setErrorMsg('Please Select Day Start Point');
      return;
    }

    if (dayEndPoint == '' || dayEndPoint == undefined) {
      setErrorMsg('Please Select Day End Point');
      return;
    }
    setLoading(false);
    try {
      let json = {
        "name": dayName,
        "overnight": overnight,
        "active": true,
        "description": description,
        "imageURL": imageName,
        "country": country.id,
        "start_latitude": parseFloat(tempDayStartPoint[0]),
        "start_longitude": parseFloat(tempDayStartPoint[1]),
        "end_latitude": parseFloat(tempDayEndPoint[0]),
        "end_longitude": parseFloat(tempDayEndPoint[1]),
        "poi_set": poiIdArray,
        "personalized": personalized
      };

      const response = await post(BASE_URL + '/days', json)
      if (response) {
        notify('Day created successfully');
        setDayName("");
        setOvernight("");
        setDayStartPoint("");
        setDayEndPoint("");
        setDescription("");
        setCountry({});
        countryRef.current = {};
        setImageName("");
        if (location && location.state && location.state.newurl)
          navigate('/days' + location.state.newurl);
        else
          navigate('/days');
      }
    }
    catch (ex) {
      alert(ex);
    }
    finally {
      setLoading(false);
    }
  }

  async function editDayFun() {

    let tempDayStartPoint = dayStartPoint.split(',');
    let tempDayEndPoint = dayEndPoint.split(',');

    if (dayName == '' || dayName == undefined) {
      setErrorMsg('Please Enter Day Name');
      return;
    }

    if (overnight == '' || overnight == undefined) {
      setErrorMsg('Overnight missing - Please Enter Overnight');
      return;
    }

    if (imageName && imageName == '' || imageName == undefined) {
      setErrorMsg('Please Upload Country Image');
      return;
    }

    if (description == '' || description == undefined) {
      setErrorMsg('Please Enter Day Description');
      return;
    }

    if (dayStartPoint == '' || dayStartPoint == undefined) {
      setErrorMsg('Please Select Day Start Point');
      return;
    }

    if (dayEndPoint == '' || dayEndPoint == undefined) {
      setErrorMsg('Please Select Day End Point');
      return;
    }
    setLoading(true);
    try {
      let json = {
        "name": dayName,
        "overnight": overnight,
        "active": true,
        "description": description,
        "imageURL": imageName,
        "country": country.id,
        "start_latitude": parseFloat(tempDayStartPoint[0]),
        "start_longitude": parseFloat(tempDayStartPoint[1]),
        "end_latitude": parseFloat(tempDayEndPoint[0]),
        "end_longitude": parseFloat(tempDayEndPoint[1]),
        "poi_set": selectedRecordsRef.current.map((item) => item.id),
        "personalized": personalized
      };

      const response = await put(BASE_URL + '/days/' + dayId, json);
      if (response) {
        notify(`Day ${friendlyId} updated successfully`);
        setDayName("");
        setOvernight("");
        setDayStartPoint("");
        setDayEndPoint("");
        setDescription("");
        setCountry({});
        countryRef.current = {}
        setImageName("");
        setDayId("");
        if (location && location.state && location.state.newurl)
          navigate('/days' + location.state.newurl);
        else
          navigate('/days');
      }
    }
    catch (ex) {
      alert(ex)
    }
    finally {
      setLoading(false);
    }
  }

  function handleUpload(url) {
    setImageName(url)
    setShowImagePopUp(false)
    setErrorMsg("")
  }

  const onDragEnd = (result) => {
    if (!result.destination) {
      return; // Drop outside the list
    }
    const reorderedItems = Array.from(selectedRecordsRef.current);
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);
    setSelectedRecords(reorderedItems);
    selectedRecordsRef.current = reorderedItems;
    let tempIdArray = []
    for (let i = 0; i < reorderedItems.length; i++) {
      tempIdArray.push(reorderedItems[i].id);
    }
    setPoiIdArray(tempIdArray);
    poiIdArrayRef.current = tempIdArray;
  };

  // function selectRowFun(props) {
  //   if (props && props.selected) {
  //     let tempPoiData = [...poiDataRef.current]; // Crear una nueva instancia del array
  //     for (let i = 0; i < tempPoiData.length; i++) {
  //       if (props.id == tempPoiData[i].id) {
  //         tempPoiData[i].selected = false;
  //       }
  //     }

  //     setPoiData(tempPoiData);
  //     poiDataRef.current = tempPoiData;

  //     let tempSelectedRecord = [...selectedRecordsRef.current]
  //     for(let i=0;i<tempSelectedRecord.length;i++){
  //       if(props.id == tempSelectedRecord[i].id){
  //         tempSelectedRecord.splice(i, 1)
  //       }
  //     }
  //     setSelectedRecords(tempSelectedRecord)
  //     selectedRecordsRef.current = tempSelectedRecord
  //     let tempPoiIdArray = [...poiIdArrayRef.current]
  //     for(let i=0;i<tempPoiIdArray.length;i++){
  //       if(props.id == tempPoiIdArray[i]){
  //         tempPoiIdArray.splice(i, 1)
  //       }
  //     }
  //     setPoiIdArray(tempPoiIdArray)
  //     poiIdArrayRef.current = tempPoiIdArray
  //   }

  //   else {
  //     let tempPoiData = poiDataRef.current
  //     let tempSelectedRecord = [...selectedRecordsRef.current]
  //     let tempPoiIdArray = [...poiIdArrayRef.current]
  //     for (let i = 0; i < tempPoiData.length; i++) {
  //       if (props.id == tempPoiData[i].id) {
  //         tempPoiData[i].selected = true
  //         tempSelectedRecord = [...tempSelectedRecord,tempPoiData[i]]
  //         tempPoiIdArray = [...poiIdArrayRef.current,tempPoiData[i].id]
  //       }
  //     }
  //     setSelectedRecords(tempSelectedRecord)
  //     selectedRecordsRef.current  = tempSelectedRecord

  //     setPoiData(tempPoiData)
  //     poiDataRef.current = tempPoiData;
  //     setPoiIdArray(tempPoiIdArray)
  //     poiIdArrayRef.current = tempPoiIdArray
  //   }
  //   gridRef.current.refresh();
  // }

  // function selectRowFunGpxs(props) {
  //   if (props && props.selected) {
  //     let tempGpxsData = [...gpxsDataRef.current]; // Crear una nueva instancia del array
  //     for (let i = 0; i < tempGpxsData.length; i++) {
  //       if (props.id == tempGpxsData[i].id) {
  //         tempGpxsData[i].selected = false;
  //       }
  //     }

  //     setGpxsData(tempGpxsData);
  //     gpxsDataRef.current = tempGpxsData;

  //     let tempSelectedRecord = [...selectedRecordsRef.current]
  //     for(let i=0;i<tempSelectedRecord.length;i++){
  //       if(props.id == tempSelectedRecord[i].id){
  //         tempSelectedRecord.splice(i, 1)
  //       }
  //     }
  //     setSelectedRecords(tempSelectedRecord)
  //     selectedRecordsRef.current = tempSelectedRecord
  //     let tempGpxsIdArray = [...gpxsIdArrayRef.current]
  //     for(let i=0;i<tempGpxsIdArray.length;i++){
  //       if(props.id == tempGpxsIdArray[i]){
  //         tempGpxsIdArray.splice(i, 1)
  //       }
  //     }
  //     setPoiIdArray(tempGpxsIdArray)
  //     gpxsIdArrayRef.current = tempGpxsIdArray
  //   }

  //   else {
  //     let tempGpxsData = gpxsDataRef.current
  //     let tempSelectedRecord = [...selectedRecordsRef.current]    

  //     let tempGpxsIdArray = [...gpxsIdArrayRef.current]
  //     for (let i = 0; i < tempGpxsData.length; i++) {
  //       if (props.id == tempGpxsData[i].id) {
  //         tempGpxsData[i].selected = true
  //         tempSelectedRecord = [...tempSelectedRecord,tempGpxsData[i]]
  //         tempGpxsIdArray = [...gpxsIdArrayRef.current,tempGpxsData[i].id]
  //       }
  //     }
  //     setSelectedRecords(tempSelectedRecord)
  //     selectedRecordsRef.current  = tempSelectedRecord

  //     setGpxsData(tempGpxsData)
  //     gpxsDataRef.current = tempGpxsData;
  //     setPoiIdArray(tempGpxsIdArray)
  //     gpxsIdArrayRef.current = tempGpxsIdArray
  //   }
  //   gridGpxRef.current.refresh();
  // }

  function selectRowFun(props) {
    if (props && props.selected) {
      let tempPoiData = [...poiDataRef.current];
      for (let i = 0; i < tempPoiData.length; i++) {
        if (props.id == tempPoiData[i].id) {
          tempPoiData[i].selected = false;
        }
      }

      setPoiData(tempPoiData);
      poiDataRef.current = tempPoiData;

      let tempSelectedRecord = [...selectedRecordsRef.current];
      for (let i = 0; i < tempSelectedRecord.length; i++) {
        if (props.id == tempSelectedRecord[i].id) {
          tempSelectedRecord.splice(i, 1);
        }
      }
      setSelectedRecords(tempSelectedRecord);
      selectedRecordsRef.current = tempSelectedRecord;
      let tempPoiIdArray = [...poiIdArrayRef.current];
      for (let i = 0; i < tempPoiIdArray.length; i++) {
        if (props.id == tempPoiIdArray[i]) {
          tempPoiIdArray.splice(i, 1);
        }
      }
      setPoiIdArray(tempPoiIdArray);
      poiIdArrayRef.current = tempPoiIdArray;
    } else {
      let tempPoiData = poiDataRef.current;
      let tempSelectedRecord = [...selectedRecordsRef.current];
      let tempPoiIdArray = [...poiIdArrayRef.current];
      for (let i = 0; i < tempPoiData.length; i++) {
        if (props.id == tempPoiData[i].id) {
          tempPoiData[i].selected = true;
          tempSelectedRecord = [...tempSelectedRecord, tempPoiData[i]];

          selectedRecordsRef.current = selectedRecordsRef.current.filter(record => record);
          selectedRecordsRef.current = selectedRecordsRef.current.filter(record => record !== null);
          tempPoiIdArray = [...selectedRecordsRef.current.map(record => record?.id), props.id];
        }
      }
      setSelectedRecords(tempSelectedRecord);
      selectedRecordsRef.current = tempSelectedRecord;
      setPoiData(tempPoiData);
      poiDataRef.current = tempPoiData;
      setPoiIdArray(tempPoiIdArray);
      poiIdArrayRef.current = tempPoiIdArray;
    }
    gridRef.current.refresh();
  }

  function selectRowFunGpxs(props) {
    if (props && props.selected) {
      let tempGpxsData = [...gpxsDataRef.current];
      for (let i = 0; i < tempGpxsData.length; i++) {
        if (props.id == tempGpxsData[i].id) {
          tempGpxsData[i].selected = false;
        }
      }

      setGpxsData(tempGpxsData);
      gpxsDataRef.current = tempGpxsData;

      let tempSelectedRecord = [...selectedRecordsRef.current];
      for (let i = 0; i < tempSelectedRecord.length; i++) {
        if (props.id == tempSelectedRecord[i].id) {
          tempSelectedRecord.splice(i, 1);
        }
      }
      setSelectedRecords(tempSelectedRecord);
      selectedRecordsRef.current = tempSelectedRecord;

      let tempGpxsIdArray = [...gpxsIdArrayRef.current];
      for (let i = 0; i < tempGpxsIdArray.length; i++) {
        if (props.id == tempGpxsIdArray[i]) {
          tempGpxsIdArray.splice(i, 1);
        }
      }
      setPoiIdArray(tempGpxsIdArray);
      gpxsIdArrayRef.current = tempGpxsIdArray;
    } else {
      let tempGpxsData = gpxsDataRef.current;
      let tempSelectedRecord = [...selectedRecordsRef.current];
      let tempGpxsIdArray = [...gpxsIdArrayRef.current];
      for (let i = 0; i < tempGpxsData.length; i++) {
        if (props.id == tempGpxsData[i].id) {
          tempGpxsData[i].selected = true;
          tempSelectedRecord = [...tempSelectedRecord, tempGpxsData[i]];
          tempGpxsIdArray = [...selectedRecordsRef.current.map(record => record.id), props.id];
        }
      }
      setSelectedRecords(tempSelectedRecord);
      selectedRecordsRef.current = tempSelectedRecord;
      setGpxsData(tempGpxsData);
      gpxsDataRef.current = tempGpxsData;
      setPoiIdArray(tempGpxsIdArray);
      gpxsIdArrayRef.current = tempGpxsIdArray;
    }
    gridGpxRef.current.refresh();
  }

  const selectTableRows = (props) => (
    <div>
      {props && props.selected ?
        <img src={SelectedCheck} style={{ width: 18, height: 18 }} onClick={() => { selectRowFun(props) }} />
        :
        <img src={UnCheck} style={{ width: 18, height: 18 }} onClick={() => { selectRowFun(props) }} />
      }
    </div>
  );

  const selectTableRowsGpxs = (props) => (
    <div>
      {props && props.selected ?
        <img src={SelectedCheck} style={{ width: 18, height: 18 }} onClick={() => { selectRowFunGpxs(props) }} />
        :
        <img src={UnCheck} style={{ width: 18, height: 18 }} onClick={() => { selectRowFunGpxs(props) }} />
      }
    </div>
  );

  return (
    <div className="m-2 ml-10 mr-10 mt-5 p-2 p-5 bg-white rounded-3xl relative">
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="loader ease-linear rounded-full border-4 border-t-4 border-white h-12 w-12 animate-spin"></div>
        </div>
      )}
      <div className="flex justify-between items-center h-20">
        <Header category="" title={fromStatus == "create" ? "Add New Day" : `Edit Day ${friendlyId}`} />
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 20 }} className="mb-10 mr-20">
          {personalized ?
            <img src={BlueCheck} style={{ height: 25, width: 25, cursor: 'pointer' }} onClick={() => { setPersonalized(!personalized) }} />
            :
            <div style={{ borderRadius: 4, height: 25, width: 25, border: '2px solid #2D96F3', cursor: 'pointer' }} onClick={() => { setPersonalized(!personalized) }} >
            </div>
          }
          <div style={{ fontSize: 22, fontWeight: 'bold' }}>Personalized</div>
          <button
            onClick={toggleDirection}
            style={{
              backgroundColor: "#007BFF", // Blue color
              color: "#fff", // White text
              border: "none",
              borderRadius: "8px", // Rounded corners
              padding: "10px 20px",
              fontSize: "16px",
              cursor: "pointer",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Shadow effect
              transition: "background-color 0.3s ease",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#007BFF")}
          >
            כיוון תצוגה ({direction === 'ltr' ? 'אנגלית' : 'עברית'})
          </button>
        </div>
      </div>
      <div className="countryFormMainDiv p-10">
        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 100 }}>
          <div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', flexDirection: 'column', gap: 10, width: '60%' }}>
              <span style={{ fontSize: 20, color: '#000', fontWeight: 'bold' }}>Name</span>
              <input type="text" className="InputBoxCss" dir={direction} style={{ width: 650 }} value={dayName} onChange={(e) => { setDayName(e.target.value) }} onFocus={() => { setErrorMsg("") }} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', flexDirection: 'column', gap: 10, marginTop: 40 }}>
              <span style={{ fontSize: 20, color: '#000', fontWeight: 'bold' }}>Description</span>
              <textarea aria-invalid="false" id="txtDescription" dir={direction} rows="5" class="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMultiline MuiOutlinedInput-inputMultiline InputBoxCss" style={{ width: 600 }} value={description} onChange={(e) => { setDescription(e.target.value) }} onFocus={() => (setErrorMsg(""))} />
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', flexDirection: 'column', gap: 10, width: '40%' }}>
            <span style={{ fontSize: 20, color: '#000' }}>Image</span>
            {imageName && imageName != "" ?
              <>
                <img src={imageName} style={{ width: 250, height: 150, borderRadius: 10 }} alt="" />
                <div className="changeImg" onClick={() => { setShowImagePopUp(true) }}>
                  Change Image
                </div>
              </>
              :
              <S3FileUpload
                onSuccess={handleUpload}
                width="350"
                height="150"
              />
            }
          </div>
        </div>

        <div
          style={{
            width: '60%'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', flexDirection: 'column', gap: 10, marginTop: 40 }}>
            <span style={{ fontSize: 20, color: '#000', fontWeight: 'bold' }}>
              Country
            </span>

            <div className='InputBoxCss' style={{ width: 350, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', padding: '5px 12px', marginTop: 10 }} onClick={() => { setShowCountrySelect(!showCountrySelect); setErrorMsg("") }}>
              {country && country.id ?
                <span style={{ color: '#000' }}>{country.name}</span>
                :
                <span style={{ color: 'gray' }}>Select Country</span>
              }
              <img src={DropDownArrow} style={{ width: 15, height: 15, transform: showCountrySelect ? "rotate(270deg)" : 'rotate(90deg)' }} />
            </div>
            {showCountrySelect &&
              <ClickAwayListener onClickAway={() => { setShowCountrySelect(false) }}>
                <div className="dropDownDiv">
                  {countryData && countryData.length > 0 && countryData.map((item, index) => (
                    <div className="countryDropDownItemDiv" onClick={() => {
                      setCountry(item);
                      countryRef.current = item;
                      setShowCountrySelect(false);
                      applyCountryFilter(item);

                    }}>
                      {item.name}
                    </div>
                  ))}
                </div>
              </ClickAwayListener>
            }
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', flexDirection: 'column', gap: 10, width: '60%' }}>
          <span style={{ fontSize: 20, color: '#000', fontWeight: 'bold' }}>Overnight</span>
          <input type="text" className="InputBoxCss" style={{ width: 300 }} value={overnight} onChange={(e) => { setOvernight(e.target.value) }} onFocus={() => { setErrorMsg("") }} />
        </div>

        <div className="selectLatLongDiv">
          <div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', flexDirection: 'column', gap: 10, width: '60%' }}>
              <span style={{ fontSize: 20, color: '#000', fontWeight: 'bold' }}>Day Start Location</span>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                  gap: 10,
                  width: '60%'
                }}
              >
                <input
                  type='text'
                  className='InputBoxCss'
                  style={{ width: 350 }}
                  placeholder='32.00, 34.00'
                  value={dayStartPoint}
                  onChange={e => {
                    let latlng = e.target.value;
                    if (e.target.value === '') {
                      setDayStartPoint("")
                      if (markerRef.current != null) {
                        markerRef.current.remove();
                      }
                    } else {
                      setDayStartPoint("")
                      if (markerRef.current != null) {
                        markerRef.current.remove();
                      }
                    }
                    latlng = latlng.trim();
                    let originalLatLng = latlng;
                    latlng = latlng.split(',');
                    if (latlng.length === 2) {
                      setDayStartPoint(originalLatLng);
                      markerRef.current = new mapboxgl.Marker()
                        .setLngLat([latlng[1].trim(), latlng[0].trim()])
                        .addTo(mapRef.current);
                      mapRef.current.flyTo({ center: [latlng[1].trim(), latlng[0].trim()], zoom: 10 });
                    }
                  }}
                  onFocus={() => setErrorMsg('')}
                />
              </div>

            </div>
            <div className="outerMapContainer">
              <div id="map" style={{ width: '100%', height: '100%' }}></div>
            </div>
          </div>
          <div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', flexDirection: 'column', gap: 10, width: '60%' }}>
              <span style={{ fontSize: 20, color: '#000', fontWeight: 'bold' }}>Day End Location</span>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                  gap: 10,
                  width: '60%'
                }}
              >
                <input
                  type='text'
                  className='InputBoxCss'
                  style={{ width: 350 }}
                  placeholder='32.00, 34.00'
                  value={dayEndPoint}
                  onChange={e => {
                    let latlng = e.target.value;
                    if (e.target.value === '') {
                      setDayEndPoint("");
                      if (marker2Ref.current != null) {
                        marker2Ref.current.remove();
                      }
                    } else {
                      setDayEndPoint("")
                      if (marker2Ref.current != null) {
                        marker2Ref.current.remove();
                      }
                    }
                    latlng = latlng.trim();
                    let originalLatLng = latlng;
                    latlng = latlng.split(',');
                    if (latlng.length === 2) {
                      setDayEndPoint(originalLatLng);
                      marker2Ref.current = new mapboxgl.Marker()
                        .setLngLat([latlng[1].trim(), latlng[0].trim()])
                        .addTo(mapRef2.current);
                      mapRef2.current.flyTo({ center: [latlng[1].trim(), latlng[0].trim()], zoom: 10 });
                    }
                  }}
                  onFocus={() => setErrorMsg('')}
                />
              </div>

            </div>
            <div className="outerMapContainer">
              <div id="map2" style={{ width: '100%', height: '100%' }}></div>
            </div>
          </div>

        </div>

        <div style={{ marginTop: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 50 }}>
            <div style={{ width: '50%', }}>
              <div style={{ marginBottom: 20, fontSize: 20, color: '#000' }}>
                Select POIs:
              </div>
              {isReady &&
                <GridComponent
                  dataSource={poiData}
                  enableHover={false}
                  allowPaging
                  pageSettings={{ pageCount: 3, pageSize: 10 }}
                  // selectionSettings={selectionsettings}
                  // toolbarClick={toolbarClick}
                  toolbar={toolbarOptions}
                  editSettings={editOptions}
                  allowSorting
                  filterSettings={FilterOptions} allowFiltering={true}
                  // rowSelected={rowSelected}
                  // rowDeselected={rowDeselected}
                  ref={gridRef}
                  showColumnChooser={true}
                  style={{ width: '100%' }}
                  actionComplete={onActionComplete}
                >
                  <ColumnsDirective>
                    <ColumnDirective template={selectTableRows} headerText="Select" width="80" />
                    {finalColumns.map((item, index) => (
                      <ColumnDirective key={index} {...item} />
                    ))}
                  </ColumnsDirective>
                  <Inject services={[Page, Toolbar, Filter, ColumnChooser]} />
                </GridComponent>
              }

            </div>

            <div style={{ width: '50%', }}>
              <div style={{ marginBottom: 20, fontSize: 20, color: '#000' }}>
                Order Selected POIs and GPXs (Drag to order):
              </div>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      <div style={{ minHeight: selectedRecords && selectedRecords.length > 0 ? 'auto' : 150, width: '100%', border: '1px solid #e0e0e0', }}>
                        {selectedRecordsRef && selectedRecordsRef.current && selectedRecordsRef.current.length > 0 && selectedRecordsRef.current[0] ?
                          <div>
                            {selectedRecordsRef && selectedRecordsRef.current.map((item, index) => (

                              <Draggable key={item.id} draggableId={item.id} index={index}>
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    <div style={{ padding: '15px 15px', borderBottom: snapshot.isDragging ? '1px solid blue' : '1px solid #e0e0e0', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 40, fontSize: 13, cursor: 'default' }}>
                                      <div style={{ width: 15, height: 15, border: '2.5px solid black', cursor: 'move' }}>
                                      </div>

                                      <div style={{ width: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {item.friendly_id ? (
                                          <a
                                            href={`/${item.typeData === 'GPX' ? 'editGpx' : 'editPoi'}/${item.friendly_id}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{ color: 'blue' }}
                                          >
                                            {item.friendly_id}
                                          </a>
                                        ) : ""}
                                      </div>
                                      <div style={{ width: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {item.name || ""}
                                      </div>
                                      <div style={{ width: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {item.country ? item.country.name || "" : ""}
                                      </div>
                                      <div style={{ width: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {item.typeData ? item.typeData || "" : ""}
                                      </div>
                                    </div>

                                    {provided.placeholder}
                                  </div>
                                )}
                              </Draggable>
                            ))}
                          </div>
                          :
                          <div style={{ height: 150, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 20, color: '#908d8d' }}>
                            No Data
                          </div>
                        }
                      </div>

                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
          </div>


        </div>
        <div style={{ marginTop: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 50 }}>
            <div style={{ width: '50%', }}>
              <div style={{ marginBottom: 20, fontSize: 20, color: '#000' }}>
                Select GPXs:
              </div>
              {isReady1 &&
                <GridComponent
                  dataSource={gpxsData}
                  enableHover={false}
                  allowPaging
                  pageSettings={{ pageCount: 3, pageSize: 10 }}
                  // selectionSettings={selectionsettings}
                  // toolbarClick={toolbarClick}
                  toolbar={toolbarOptions}
                  editSettings={editOptions}
                  allowSorting
                  filterSettings={FilterOptions} allowFiltering={true}
                  // rowSelected={rowSelected}
                  // rowDeselected={rowDeselected}
                  showColumnChooser={true}
                  ref={gridGpxRef}
                  style={{ width: '100%' }}
                  actionComplete={onActionComplete1}
                >
                  <ColumnsDirective>
                    <ColumnDirective template={selectTableRowsGpxs} headerText="Select" width="80" />
                    {finalColumns1.map((item, index) => (
                      <ColumnDirective key={index} {...item} />
                    ))}
                  </ColumnsDirective>
                  <Inject services={[Page, Toolbar, Filter, ColumnChooser]} />
                </GridComponent>
              }
            </div>

            <div style={{ width: '50%', }}>
            </div>
          </div>
        </div>

        {errorMsg != '' &&
          <div style={{ textAlign: 'center', color: 'red', fontSize: 16, marginTop: 30, }}>
            {errorMsg}
          </div>
        }
        {fromStatus == "create" ?
          <div className="AddBtn" onClick={() => { createDayFun() }}>
            Add
          </div>
          :
          <div className="AddBtn" onClick={() => { editDayFun() }}>
            Update day {friendlyId}
          </div>
        }

      </div>

      {showImagePopUp && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
          onClick={() => { setShowImagePopUp(false) }}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: 10,
              padding: '15px'
            }}
            onClick={e => e.stopPropagation()}
          >
            <S3FileUpload
              onSuccess={handleUpload}
              width="350"
              height="150"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateDay;
